import SVG, { CustomSVGProps } from '@/src/components/common/SVG/SVG'

export default function SVGBurgerMenu(props: CustomSVGProps) {
  return (
    <SVG viewBox="0 0 18 16" {...props}>
      <path d="M18 4H0V0H18V4ZM18 6H0V10H18V6ZM18 12H0V16H18V12Z" fill="black" fillOpacity={0.56} />
    </SVG>
  )
}
